<div class="w-full flex flex-col gap-4 p-4" [formGroup]="form">
    <app-page-header urlPath="lista-tutorial"></app-page-header>

    <p-card class="md:max-w-250">
        <div class="w-full flex flex-col gap-4">
            <h1 class="text-2xl font-bold">Cadastrar/Editar Tutorial</h1>

            <div class="w-full grid md:grid-cols-2 grid-cols-1 gap-4 items-end">
                <app-input
                    id="descricao"
                    label="Descrição"
                    formControlName="Descricao"
                    class="md:col-span-2"
                ></app-input>

                <app-input
                    id="link"
                    label="Link"
                    formControlName="Link"
                    class="md:col-span-2"
                ></app-input>

                <app-input
                    id="classificacao"
                    label="Classificação"
                    formControlName="Classificacao"
                    class="md:col-span-2"
                ></app-input>

                <app-text-area
                    id="textodetalhe"
                    label="Texto Detalhe"
                    formControlName="Texto"
                    class="md:col-span-2"
                ></app-text-area>

                <div class="w-full flex items-end gap-2">
                    <app-select
                        id="rotina"
                        label="Rotina"
                        [icon]="true"
                        [options]="rotinaSelect"
                        formControlName="IdRotina"
                        class="flex-1 min-w-0"
                    ></app-select>

                    <app-button
                        icon="fa fa-plus"
                        [fullWidth]="false"
                        class="w-10"
                        (click)="modalRotina = true"
                    ></app-button>
                </div>

                <app-select
                    id="tipoconteudo"
                    label="Tipo de Conteúdo"
                    [icon]="true"
                    [options]="tipoConteudo"
                    formControlName="TipoConteudo"
                ></app-select>
            </div>

            <div
                class="w-full flex sm:flex-row flex-col gap-4 justify-end items-end"
            >
                <app-button
                    variant="danger"
                    (click)="cancelar()"
                    class="md:max-w-45 w-full"
                    >Cancelar</app-button
                >

                <app-button
                    variant="success"
                    (click)="processarFormulario()"
                    class="md:max-w-45 w-full"
                    >Salvar</app-button
                >
            </div>
        </div>
    </p-card>
</div>

<app-modal-rotina-cadastro
    [modalVisible]="modalRotina"
    (closeModal)="modal($event)"
></app-modal-rotina-cadastro>
